import Gravity from "Gravity";

const detectAPI = () => {
    if (!document.querySelector(".gg-detect-api")) {
        return;
    }

    const setCookieFUll = (name, value, days) => {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }

    const getCookie = (name) => {
        const nameEQ = `${name}=`;
        const cookiesArray = document.cookie.split(';');
        for (let cookie of cookiesArray) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length);
            }
        }
        return null;
    };

    const checkStateAPI = () => {
        const cookieName = 'userState';
        const euCountries = ['uk', 'at', 'be', 'bg', 'gb', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se'];
        let state = getCookie(cookieName);
    
        if (state) {
            if (euCountries.includes(state)) {
                window.location.href = '/';
            }
        } else {
            try {
              fetch('https://www.cloudflare.com/cdn-cgi/trace')
                .then(response => response.text())
                .then(text => {
                  state = text.match(/loc=(.+)/)[1].toLowerCase();
                  setCookieFUll(cookieName, state, 7);
                  if (euCountries.includes(state)) {
                    window.location.href = '/';
                  }
                  return true;
                })
                .catch(error => {
                  console.error('Error fetching state:', error);
                  return false;
                })
               
            } catch (error) {
                console.error('Error fetching state:', error);
                return false;
            }
        }
    }

    checkStateAPI();
};
Gravity.ready(detectAPI);
